import { render, staticRenderFns } from "./user-action-list.vue?vue&type=template&id=097ffc91&scoped=true"
import script from "./user-action-list.vue?vue&type=script&lang=js"
export * from "./user-action-list.vue?vue&type=script&lang=js"
import style0 from "./user-action-list.vue?vue&type=style&index=0&id=097ffc91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097ffc91",
  null
  
)

export default component.exports